import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { togglePlanSection } from "../../../../../actions/show_modal_Action";
import { baseUrl } from "../../../../../utils";

const CssUpgrade = ({ onHide }) => {

    const dispatch = useDispatch();
   
    return (
        <Modal
            size="lg"
            dialogClassName=" modal-dialog-centered modal-dialog"
            show={true}
            onHide={onHide}
        >
            <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
            <Modal.Body>
                <div className="row py-5">
                    <div className="col-lg-12">
                        <div className="upgredeMain text-center">
                            <div className="Errorimage pb-3"><img src={baseUrl(`error/custom-css-error.png`)} className="img-fluid" width={500} height={300}  /></div>
                            <div className="permissionMsg my-4 px-4">
                                <h4 className="ErrorMsg">Custom CSS</h4>
                                <p className="msgSec">Use custom CSS and modify widget content according to your requirements beyond Taggbox`s default settings.</p>
                            </div>
                            <div className="buttonUpgred mb-3">
                                <Button variant="primary" id="addonFeaturesScroll" onClick={(e) => dispatch(togglePlanSection(true))} className="commanBtn px-5" data-factors-click-bind="true">
                                    Upgrade Now
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default CssUpgrade